import styled from 'styled-components';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	text-align: left;
	margin: 0;
`;

export const SuccessHeader = styled.h4`
	margin-top: 0;
	${fontWeight(FontWeights.Light)};

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const SuccessText = styled.div`
	margin-top: 24px;
	p {
		margin-bottom: 24px;
	}
`;

export const StoreButtonsWrapper = styled.div`
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	width: 260px;
	margin-bottom: 24px;
`;

export const AppleButtonWrapper = styled.div`
	display: inline;
	cursor: pointer;
`;

export const GoogleButton = styled.img`
	cursor: pointer;
	width: 120px;
	height: 40px;
`;

export const LoaderContainer = styled.div`
	margin: 4rem auto;
`;
